export default {"src":"/_next/static/media/swap-fee.d95fa4ad.svg","height":24,"width":24};